import { Dispatch, SetStateAction, useEffect, useRef } from 'react'
import { ListItemText, Tooltip } from '@mui/material'
import { useHasEllipsis } from '@global/hooks'
import * as css from '../styles'

interface Props {
  name: string
  setEllipsisActive: Dispatch<SetStateAction<boolean>>
}

export const ListItemLabel = ({ name, setEllipsisActive }: Props) => {
  const ref = useRef<HTMLSpanElement | null>(null)

  const showTooltip = useHasEllipsis({
    parentElRef: ref,
    childElRef: ref,
    definedMaxWidth: css.MAX_LABEL_WIDTH,
  })

  useEffect(() => {
    setEllipsisActive(showTooltip)
  }, [showTooltip])

  return (
    <Tooltip title={showTooltip ? name : ''} placement="bottom-start">
      <ListItemText
        primary={
          <span css={css.smallerFont} ref={ref}>
            {name}
          </span>
        }
      />
    </Tooltip>
  )
}
